module.exports = __webpack_public_path__ + "static/assets/91d08ac3fa76c183ccd345334127ca2f.png";